import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck, Heart } from 'lucide-react';
export function CTASection() {
  return <Section background="card" className="text-center relative overflow-hidden border-y border-navy-border" data-id="element-38">
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-accent to-transparent opacity-50" data-id="element-39" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent rounded-full opacity-5 blur-[100px] transform translate-y-1/2 translate-x-1/2" data-id="element-40" />
      <div className="absolute top-0 left-0 w-96 h-96 bg-accent rounded-full opacity-5 blur-[100px] transform -translate-y-1/2 -translate-x-1/2" data-id="element-41" />

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="relative z-10 max-w-3xl mx-auto py-8" data-id="element-42">
        <Heart className="w-12 h-12 text-accent mx-auto mb-6 opacity-80" data-id="element-43" />

        <h2 className="font-serif text-3xl md:text-5xl text-white mb-6 leading-tight" data-id="element-44">
          El amor no es algo que se encuentra,{' '}
          <span className="text-accent italic" data-id="element-45">es algo que se construye</span>
        </h2>

        <p className="text-lg md:text-xl text-muted mb-10 max-w-2xl mx-auto" data-id="element-46">
          Estás a un clic de distancia de las herramientas que pueden
          transformar tu relación para siempre. Empezá hoy.
        </p>

        <div className="flex flex-col items-center gap-6" data-id="element-47">
          <Button variant="primary" size="lg" className="w-full sm:w-auto text-lg px-12 py-5" icon href="https://vinculosdehierro.mujerdigital2.com/cart/42635616780375:1" data-id="element-48">
            OBTENER VÍNCULOS DE HIERRO
          </Button>

          <div className="flex items-center justify-center gap-3" data-id="element-49">
            <span className="text-3xl font-bold text-white" data-id="element-50">
              $9.900 <span className="text-sm text-muted font-normal" data-id="element-51">ARS</span>
            </span>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-muted pt-4" data-id="element-52">
            <span className="flex items-center gap-2" data-id="element-53">
              <ShieldCheck size={16} className="text-accent" data-id="element-54" /> Compra segura
            </span>
            <span className="flex items-center gap-2" data-id="element-55">
              <ShieldCheck size={16} className="text-accent" data-id="element-56" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-2" data-id="element-57">
              <ShieldCheck size={16} className="text-accent" data-id="element-58" /> Garantía 7 días
            </span>
          </div>
        </div>
      </motion.div>
    </Section>;
}